/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is NOT imported — application runs in zoneless mode.
 * Change detection is driven by provideExperimentalZonelessChangeDetection() in main.ts.
 */
// (window as any).process = {
//     env: { DEBUG: undefined,
    
//         sessionSampleRate: 1,
//         RUM_GUEST_ROLE_ARN: "process.env.RUM_GUEST_ROLE_ARN",
//         RUM_CONFIG_IDENTITY_POOL_ID:" process.env.RUM_CONFIG_IDENTITY_POOL_ID",
//         RUM_ENDPOINT:" process.env.RUM_ENDPOINT",
//         RUM_CONFIG_TELEMETRIES:" process.env.RUM_CONFIG_TELEMETRIES",
//         RUM_CONFIG_ALLOW_COOKIES: "process.env.RUM_CONFIG_ALLOW_COOKIES",
//         RUM_CONFIG_ENABLE_XRAY:" process.env.RUM_CONFIG_ENABLE_XRAY",
//         RUM_APPLICATION_ID: "process.env.RUM_APPLICATION_ID",
//         RUM_APPLICATION_REGION: "process.env.RUM_APPLICATION_REGION",
//     },
//   };

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any)['global'] = window;